var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPerplexity = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    flex: "none",
    lineHeight: 1
  },
  viewBox: "0 0 24 24",
  ref: ref
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Perplexity")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#22B8CD",
  d: "M19.785 0v7.272H22.5V17.62h-2.935V24l-7.037-6.194v6.145h-1.091v-6.152L4.392 24v-6.465H1.5V7.188h2.884V0l7.053 6.494V.19h1.09v6.49L19.786 0zm-7.257 9.044v7.319l5.946 5.234V14.44l-5.946-5.397zm-1.099-.08-5.946 5.398v7.235l5.946-5.234zm8.136 7.58h1.844V8.349H13.46l6.105 5.54zm-8.982-8.28H2.59v8.195h1.8v-2.576zM5.475 2.476v4.71h5.115zm13.219 0-5.115 4.71h5.115z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPerplexity);
export default ForwardRef;